import React from "react";
import { FaStar, FaBook, FaUser, FaClock } from "react-icons/fa";
import { Link } from "react-router-dom";

const Course = ({ course }) => {
	const {
		name,price,
		id,
		author_name,
		author_img,
		img,
		Duration,
		Enrolled,
		Lessons,
		rating,
	} = course;
	return (
		<div className="col-md-4">
			<div className=" my-3 p-3 border border-3 bg-white rounded theme_color position-relative">
				<img className="img-fluid w-100 rounded" src={img} alt="" />
						<div style={{right:  '0'}} className="bg-black fs-3 text-white rounded px-4 py-2 d-inline-block position-absolute fw-bolder">
							${price}
						</div>
				<h5 className="fw-bolder mt-4">{name}</h5>
				<div className="author-info d-flex mt-4 align-items-center justify-content-between">
					<div className="d-flex align-items-center">
						<img
							src={author_img}
							width="50px"
							className="rounded-circle"
							alt=""
						/>{" "}
						<span className="fw-bold ms-2">{author_name}</span>
					</div>
					<div className="fw-bolder">
						<FaStar></FaStar>
						<FaStar></FaStar>
						<FaStar></FaStar>
						<FaStar></FaStar>
						<FaStar className="me-2"></FaStar>
						{rating}
					</div>
				</div>
				<div className="border border-bottom border-top d-flex fw-bold justify-content-between mt-3 px-2 py-3 d-flex">
					<div>
						<FaBook></FaBook> {Lessons}
					</div>
					<div>
						<FaUser></FaUser> {Enrolled}
					</div>
					<div>
						<FaClock></FaClock> {Duration}
					</div>
				</div>
                <div className="d-flex justify-content-between my-3">
                    <Link to="/checkout"><button className="btn bg-black border-0 px-4 py-2 fw-bolder text-white">Buy Now</button></Link>
                    <Link to={`/courses/${id}`}><button className="btn bg-black border-0 px-4 py-2 fw-bolder text-white">See Details</button></Link>
                </div>
			</div>
		</div>
	);
};

export default Course;
